import React, { useRef, useState } from "react";
import Slider from "react-slick";
import Lightbox from "yet-another-react-lightbox";
import "yet-another-react-lightbox/styles.css";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import "./Macau.css";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { Container, Row, Col } from "react-bootstrap";
import AnimateOnScroll from "../AnimateOnScroll/AnimateOnScroll";
import ImageLoader from "../ImageLoader/ImageLoader";
import { useTranslation } from "react-i18next";

const Macau = () => {
  const { t } = useTranslation();
  const sliderRef = useRef(null);

  const [lightbox, setLightbox] = useState({
    open: false,
    slides: [],
    index: 0,
  });

  const openLightbox = (slides, index) => {
    setLightbox({
      open: true,
      slides,
      index,
    });
  };

  const sliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    centerMode: false,
    arrows: false, // We are using custom arrows
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const sliderContent = [
    <div className="image-card" key={0}>
      <img src="/images/new_27_2.jpg" alt="" />
    </div>,
    <div className="image-card" key={1}>
      <img src="/images/new_22.jpg" alt="" />
    </div>,
    <div className="image-card" key={2}>
      <img src="/images/new_24_1.jpg" alt="" />
    </div>,
    <div className="image-card" key={3}>
      <img src="/images/new_23.jpg" alt="" />
    </div>,
  ];

  const slides = sliderContent.map((card) => ({
    src: card.props.children.props.src,
  }));

  return (
    <ImageLoader>
      <Container>
        <Row>
          <Col>
            <div className="section">
              <AnimateOnScroll animationType="slideUp">
                <h2>{t("macau_main_title")}</h2>
                <p>{t("macau_main_p")}</p>
                <video autoPlay muted loop style={{ width: "100%" }}>
                  <source
                    src="/images/videos/Oasis Macu sight.mp4"
                    type="video/mp4"
                  />
                </video>
              </AnimateOnScroll>
            </div>
          </Col>
        </Row>
        <Row>
          <Col md={12}>
            <div className="section">
              <AnimateOnScroll animationType="slideUp">
                <h2>{t("macau_stability_title")}</h2>
                <p>{t("macau_stability_p")}</p>
              </AnimateOnScroll>
            </div>
          </Col>
          <Col md={12}>
            <div className="section">
              <AnimateOnScroll animationType="slideUp">
                <div className="image-slider">
                  <div className="slider-container">
                    <button
                      className="slick-prev-custom"
                      onClick={() => sliderRef.current.slickPrev()}
                    >
                      <FaArrowLeft />
                    </button>
                    <div className="slider-wrapper">
                      <Slider ref={sliderRef} {...sliderSettings}>
                        {sliderContent.map((card, idx) =>
                          React.cloneElement(card, {
                            onClick: () => openLightbox(slides, idx),
                          }),
                        )}
                      </Slider>
                    </div>
                    <button
                      className="slick-next-custom"
                      onClick={() => sliderRef.current.slickNext()}
                    >
                      <FaArrowRight />
                    </button>
                  </div>
                </div>
              </AnimateOnScroll>
            </div>
          </Col>
        </Row>
        <Row className="section">
          <Col md={4}>
            <AnimateOnScroll animationType="slideRight">
              <img src="/images/sky_01.jpg" alt="Macau" className="fullimg" />
            </AnimateOnScroll>
          </Col>
          <Col md={8} className="d-flex flex-column">
            <AnimateOnScroll animationType="slideLeft">
              <div>
                <h2
                  dangerouslySetInnerHTML={{ __html: t("macau_growth_title") }}
                 class="desktopbottomspacing" />
                <p>{t("macau_growth_p")}</p>
              </div>
            </AnimateOnScroll>

            <Row className="mt-auto">
              <Col md={6}>
                <img
                  src="/images/02_02.jpg"
                  alt="Macau"
                  className="fullimgcover"
                />
              </Col>
              <Col md={6}>
                <img
                  src="/images/I12.jpg"
                  alt="Macau"
                  className="fullimgcover"
                />
              </Col>
            </Row>
          </Col>
        </Row>
        <Lightbox
          open={lightbox.open}
          close={() => setLightbox({ ...lightbox, open: false })}
          slides={lightbox.slides}
          index={lightbox.index}
        />
      </Container>
    </ImageLoader>
  );
};

export default Macau;
